<img src="https://firebasestorage.googleapis.com/v0/b/kajimotomusic-prod.appspot.com/o/theme%2Fkajimoto.gif?alt=media&token=cbf9e1b3-d788-49bb-9149-675bbc7cdc0e" class="logo-login logo-login-xs">

<div *ngIf="auth.user | async as user">
	<app-user-dashboard  
		[agentkey]="user.memberkey"
	 	[userDisplayName]="user.displayName" 
	 	[user]="user">
	</app-user-dashboard>
</div>